import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const outcomeCardsCss = `
  /* Outcomes Layout (Why slides / positive & negative outcomes) */
  .outcome-container {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &.centered-container {
      align-items: center;
      margin: 0 auto;
      width: 100%;

      .content-so-what {
        width: 100%;
        max-width: 740px;
        margin: 18px auto 12px auto;
        box-sizing: border-box;
      }
    }
  }

  .outcome-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    width: 100%;
    align-items: stretch;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    &.centered-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      justify-content: center;
      align-items: stretch;
      gap: 20px;
      width: 100%;
      max-width: 740px;
      margin: 0 auto;

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
        max-width: 360px;
      }
    }
  }

  .outcome-card {
    border-radius: 10px;
    padding: 14px 16px;
    border: 1px solid;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    &.positive {
      background: #f0fdf4;
      border-color: #dcfce7;
    }

    &.negative {
      background: #fffbeb;
      border-color: #fef3c7;
    }
  }

  .outcome-card-image-wrap {
    width: 100%;
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
  }

  .outcome-card-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }

  .outcome-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .outcome-icon {
    font-size: 0.95rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .outcome-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    &.positive {
      color: #14532d;
    }

    &.negative {
      color: #92400e;
    }
  }

  .outcome-body {
    font-size: 0.9rem;
    line-height: 1.45;
    margin: 0;
    text-align: left;

    &.positive {
      color: #14532d;
    }

    &.negative {
      color: #78350f;
    }
  }

  .outcome-takeaway-container {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    width: 100%;
  }

  .outcome-takeaway-text {
    font-size: 0.9rem;
    color: #374151;
    line-height: 1.45;
    margin: 0;
    text-align: left;
  }

  .content-so-what {
    font-size: 0.95rem;
    font-weight: 700;
    color: #065f46;
    background: #ecfdf5;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 18px;
    margin-bottom: 12px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #10b981;

    &::before {
      content: "";
    }
  }
`;

export const OutcomeContainer = styled(Box)`
  width: 100%;
  margin-top: 12px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &.centered-container {
    align-items: center;
    margin: 0 auto;
    width: 100%;

    .content-so-what {
      width: 100%;
      max-width: 740px;
      margin: 18px auto 12px auto;
      box-sizing: border-box;
    }
  }
`;

export const OutcomeGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  width: 100%;
  align-items: stretch;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }

  &.centered-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-content: center;
    align-items: stretch;
    gap: 20px;
    width: 100%;
    max-width: 740px;
    margin: 0 auto;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      max-width: 360px;
    }
  }
`;

export const OutcomeCard = styled(Box)`
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  box-sizing: border-box;

  &.positive {
    background: #f0fdf4;
    border-color: #dcfce7;
  }

  &.negative {
    background: #fffbeb;
    border-color: #fef3c7;
  }
`;

export const OutcomeCardImageWrap = styled(Box)`
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
`;

export const OutcomeCardImage = styled('img')`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  display: block;
  user-select: none;
  -webkit-user-drag: none;
`;

export const OutcomeHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const OutcomeIcon = styled('span')`
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const OutcomeTitle = styled(Typography)`
  font-weight: 800;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &.positive {
    color: #14532d;
  }

  &.negative {
    color: #92400e;
  }
`;

export const OutcomeBody = styled(Typography)`
  font-size: 0.9rem;
  line-height: 1.45;
  margin: 0;
  text-align: left;

  &.positive {
    color: #14532d;
  }

  &.negative {
    color: #78350f;
  }
`;

export const OutcomeTakeawayContainer = styled(Box)`
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
  width: 100%;
`;

export const OutcomeTakeawayText = styled(Typography)`
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.45;
  margin: 0;
  text-align: left;
`;

export const ContentSoWhat = styled(Box)`
  font-size: 0.95rem;
  font-weight: 700;
  color: #065f46;
  background: #ecfdf5;
  border-radius: 10px;
  padding: 12px 16px;
  margin-top: 18px;
  margin-bottom: 12px;
  line-height: 1.55;
  text-align: left;
  border-left: 3px solid #10b981;

  &::before {
    content: "";
  }
`;
